module.exports = __webpack_public_path__ + "img/document-up.eeae67c4.svg";